import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Optional, Self } from '@angular/core';
import { ControlContainer, NgControl } from '@angular/forms';
import { MatFormFieldControl } from '@angular/material/form-field';
import { BaseGenericInputComponent } from '../base-generic-input/base-generic-input.component';

@Component({
    selector: 'mat-generic-daterange-input',
    templateUrl: './generic-daterange-input.component.html',
    styleUrls: [ '../base-generic-input/base-generic-input.component.scss', './generic-daterange-input.component.scss' ],
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [
        {
            provide: MatFormFieldControl,
            useExisting: GenericDaterangeInputComponent,
        },
    ],
})
export class GenericDaterangeInputComponent extends BaseGenericInputComponent<{ start: string, end: string }> {

    constructor(
        @Optional()
        @Self()
        protected myNgControl: NgControl,
        public myControlContainer: ControlContainer,
        protected myChangeDetectorRef: ChangeDetectorRef,
    ) {
        super(myChangeDetectorRef);

        if (this.myNgControl) {
            this.myNgControl.valueAccessor = this;
        }
    }

}
